function baseGt(e,t){return t<e}module.exports=baseGt;